import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { AnimatedViews, HStack } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProfileFormLoading = (props: Props) => {
  const { hasZipCodeField } = props;

  const fieldIndexes = [...Array(hasZipCodeField ? 5 : 4).keys()];

  return (
    <>
      {fieldIndexes.map((index) => (
        <AnimatedViews.Pulse key={index} index={index} style={styles.fieldGroup}>
          <View style={styles.fieldLabel} />

          <View style={styles.field}>
            <View style={styles.fieldValue} />
          </View>
        </AnimatedViews.Pulse>
      ))}

      <AnimatedViews.Pulse index={fieldIndexes.length} style={styles.fieldGroup}>
        <View style={styles.birthdayLabel} />

        <HStack itemsPerRow={2}>
          <View style={styles.birthdaySelect} />

          <View style={styles.birthdaySelect} />
        </HStack>

        <View style={styles.birthdayHelperText} />
      </AnimatedViews.Pulse>

      <AnimatedViews.Pulse index={fieldIndexes.length + 1}>
        <HStack itemsPerRow={2} style={styles.buttons}>
          <View style={styles.button} />

          <View style={styles.button} />
        </HStack>

        <View style={styles.deleteAccountLink} />
      </AnimatedViews.Pulse>
    </>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  fieldGroup: {
    paddingBottom: theme.spacing['5'],
  },
  fieldLabel: {
    width: 64,
    height: 10,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  field: {
    height: 31,
    justifyContent: 'center',
    marginTop: 2,
    marginBottom: theme.spacing['6'],
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.GRAY,
  },
  fieldValue: {
    width: '40%',
    height: 14,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  birthdayLabel: {
    width: 64,
    height: 10,
    marginTop: 3,
    marginBottom: 19,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  birthdaySelect: {
    height: 32,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  birthdayHelperText: {
    width: 240,
    height: 10,
    marginTop: 19,
    marginBottom: 3,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  buttons: {
    paddingTop: theme.spacing['4'],
  },
  button: {
    height: 48,
    borderRadius: theme.radius['3xLarge'],
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
  deleteAccountLink: {
    alignSelf: 'center',
    width: 108,
    height: 14,
    marginTop: theme.spacing['11'],
    marginBottom: 4,
    borderRadius: theme.radius.small,
    backgroundColor: theme.colors.OPACITY.DARK_KALE.LIGHTEST,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  hasZipCodeField: boolean;
};
